export default __webpack_public_path__ + "static/media/pause_icon.ef0d2b3e.svg";